import { createApp } from "vue/dist/vue.esm-bundler";

import AddProductToCartForm from './components/AddProductToCartForm.vue'
import FlashMessage from './components/FlashMessage.vue'
import PaginatedSliderSection from './components/PaginatedSliderSection.vue'
import ProductImageGalleryDialog from './components/ProductImageGalleryDialog.vue'
import ProductInformationNav from './components/ProductInformationNav.vue'
import ProductDetails1 from './components/ProductDetails1.vue'
import ProductReviews1 from './components/ProductReviews1.vue'
import * as Sentry from "@sentry/vue";
const app = createApp({
   components: {
      FlashMessage,
      AddProductToCartForm,
      PaginatedSliderSection,
      ProductImageGalleryDialog,
      ProductInformationNav,
      ProductDetails1,
      ProductReviews1,
   }
})
Sentry.init({
   app,
   dsn: "https://e65e33215a4c2a9d51c995d28ab5b41e@o4507070871699456.ingest.us.sentry.io/4507070876876800",
   integrations: [
     Sentry.browserTracingIntegration(),
     Sentry.replayIntegration(),
   ],
   // Performance Monitoring
   tracesSampleRate: 1.0, //  Capture 100% of the transactions
   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
   // Session Replay
   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
 });
app.config.globalProperties.eventBus = window.eventBus
app.mount('#app');